export const defaultFields = [
    'ЛПУ',
    'Вид помощи',
    'Адрес',
    'Метро',
    'Телефон',
    'Форма обслуживания',
];
export const allFields = [
    'ЛПУ',
    'Вид помощи',
    'Адрес',
    'Метро',
    'Телефон',
    'Форма обслуживания',
    'Регион',
    'Детское отделение',
    'Наличие франшизы',
    'Размер франшизы'
];
export const fieldMappings: Record<string, string> = {
    'ЛПУ': 'HospitalFullName',
    'Вид помощи': 'Risks',
    'Адрес': 'AddressName',
    'Метро': 'MetroName',
    'Телефон': 'TaskNumber',
    'Форма обслуживания': 'ServiceFormName',
    'Регион': 'RegionName',
    'Детское отделение': 'HasChildDepartment',
    'Наличие франшизы': 'HasFranchise',
    'Размер франшизы': 'FranchiseValue',
};